import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const ELFSIGHT_FORM_SCHEMA: GsFormSchema = {
  fields: [...ACTIVE_SCHEMA_FIELDS, ...BASIC_SCHEMA_FIELDS, ...SPACING_SCHEMA]
};
